import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ITextBuilder from "../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import ICheckBuilder from "../../../../toolkit/baseForms2/iCheckBuilder/ICheckBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import IClubSelectorBuilder from "../../../../toolkit/baseForms2Commons/iClubSelectorBuilder/IClubSelectorBuilder";
import IUserSelectorBuilder from "../../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";

const mesesOpts = [
  { value: "01", label: "Enero" },
  { value: "02", label: "Febrero" },
  { value: "03", label: "Marzo" },
  { value: "04", label: "Abril" },
  { value: "05", label: "Mayo" },
  { value: "06", label: "Junio" },
  { value: "07", label: "Julio" },
  { value: "08", label: "Agosto" },
  { value: "09", label: "Septiembre" },
  { value: "10", label: "Octubre" },
  { value: "11", label: "Noviembre" },
  { value: "12", label: "Diciembre" }
];

const currentYear = new Date().getFullYear();
const aniosOpts = [
  { label: currentYear - 1, value: currentYear - 1 },
  { label: currentYear - 2, value: currentYear - 2 }
];

export type Inputs =
  | "tipoBusqueda"
  | "folioFactura"
  | "mes"
  | "anio"
  | "idVendedor"
  | "idClub"
  | "soloContactCenter"
  | "conCambios"
  | "evaluadorModifico";
export type Buttons = "buscar" | "generarSnapshot";

const hiddenIfNotFactura = values => values.tipoBusqueda !== "factura";
const hiddenIfFactura = values => values.tipoBusqueda === "factura";
const hiddenIfNotAsesor = values => values.tipoBusqueda !== "asesor";
const hiddenIfNotPeriodo = values => !!values.tipoBusqueda;

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "tipoBusqueda",
      label: "Tipo de Búsqueda",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Por Periodo",
        data: [
          { value: "factura", label: "Por Factura" },
          { value: "asesor", label: "Por Asesor" }
        ]
      }
    },
    {
      name: "folioFactura",
      label: "Folio de Factura",
      bts: { mCol: 3 },
      component: ITextBuilder,
      props: {
        uppercase: true,
        hidden: hiddenIfNotFactura
      }
    },
    {
      name: "mes",
      label: "* Mes",
      bts: { mCol: 3 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione",
        data: mesesOpts,
        hidden: hiddenIfFactura
      }
    },
    {
      name: "anio",
      label: "Año",
      bts: { mCol: 3 },
      component: ISelectBuilder,
      props: {
        emptyLabel: currentYear.toString(),
        data: aniosOpts,
        hidden: hiddenIfFactura
      }
    },
    {
      name: "idVendedor",
      label: "Vendedor",
      bts: { mCol: 4 },
      component: IUserSelectorBuilder,
      props: {
        hidden: hiddenIfNotAsesor
      }
    },
    {
      name: "idClub",
      label: "Club",
      bts: { mCol: 4 },
      component: IClubSelectorBuilder,
      props: {
        hidden: hiddenIfNotPeriodo
      }
    },
    {
      name: "soloContactCenter",
      label: "Ventas de C. Center",
      bts: { mCol: 2, mOff: 6 },
      component: ICheckBuilder,
      props: {
        hidden: hiddenIfNotPeriodo,
        addTopMargin: false
      }
    },
    {
      name: "conCambios",
      label: "Ventas con cambios",
      bts: { mCol: 2 },
      component: ICheckBuilder,
      props: {
        hidden: hiddenIfNotPeriodo,
        addTopMargin: false
      }
    },
    {
      name: "evaluadorModifico",
      label: "Ventas gestionadas",
      bts: { mCol: 2 },
      component: ICheckBuilder,
      props: {
        hidden: hiddenIfNotPeriodo,
        addTopMargin: false
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: { mCol: 3, mOff: 6 },
      component: IButtonBuilder,
      props: {
        addTopMargin: false
      }
    },
    {
      name: "generarSnapshot",
      label: "Generar Snapshot",
      isSubmit: false,
      bts: { mCol: 3 },
      component: IButtonBuilder,
      props: {
        addTopMargin: false
      }
    }
  ],
  validations: {
    folioFactura: {
      requiredIfFactura: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda === "factura" && !value,
        message: () => "El folio factura es requerido para búsqueda por folio"
      }
    },
    mes: {
      requiredIfNotFactura: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda !== "factura" && !value,
        message: () => "El periodo es requerido"
      }
    },
    idVendedor: {
      requiredIfAsesor: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda === "asesor" && !value,
        message: () => "El ID Vendedor es requerido para búsqueda por asesor"
      }
    }
  },
  rows: [
    ["tipoBusqueda", "folioFactura", "mes", "anio", "idVendedor", "idClub"],
    ["soloContactCenter", "conCambios", "evaluadorModifico"],
    ["buscar", "generarSnapshot"]
  ]
};
